import React from "react";
import CountrySettingsContent from "../components/countrySettings/countrySettings-content";

const CountrySettings = () => {
  return <CountrySettingsContent />;
};

export default CountrySettings;
